import lapdev from '../../lapdev';

export function inviteUser(data) {
  return lapdev.post('users/invite', data);
}
